import React from 'react';
import { Clock } from 'lucide-react';

function timeAgo(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diff = Math.max(0, (Date.now() - then) / 1000); // seconds
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}

const UpdatedAtBadge = ({ updatedAt, actor }) => {
  const rel = timeAgo(updatedAt);
  if (!rel) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] text-gray-500 bg-gray-50 border border-gray-200 rounded-full px-2 py-1"
      title={updatedAt ? new Date(updatedAt).toLocaleString() : ''}
      data-testid="updated-at-badge"
    >
      <Clock className="w-3 h-3" />
      Last edited {rel}
      {actor ? <span className="text-gray-400"> · by {actor}</span> : null}
    </span>
  );
};

export default UpdatedAtBadge;
